export const types = {
    SAVE_EMAIL: 'SAVE_EMAIL',
    SAVE_EMAIL_SUCCESS: 'SAVE_EMAIL_SUCCESS',
    SAVE_EMAIL_FAIL: 'SAVE_EMAIL_FAIL',

    RECOMMEND: 'RECOMMEND',
    RECOMMEND_SUCCESS: 'RECOMMEND_SUCCESS',
    RECOMMEND_FAIL: 'RECOMMEND_FAIL',
};

export type TInvitationType = 'general' | 'event' | 'contest' | 'campaign' | 'audition' | 'role';
export interface IRecommend {
    recipient_email?: string;
    recipient_phone?: string;
    invitation_type: TInvitationType;
    /** ID of the model. e.g audition, event etc */
    reference_id: string;
}
